<template>
  <div>
    <!-- Available Ticket -->  
    <v-dialog v-model="availableTicketModal" width="1200" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn depressed large class="btn-success" @click="openAvailableTicketModal">
          Book Tickets
        </v-btn>
      </template>
      <v-card class="event-modal__wrap ra lobby__bg">
        <div class="ra__form-heading lobby__bg">
          <v-card-title class="ra__modal-title">
            <h3 class="ra__modal-title--heading lobby__bg-text">Available Tickets</h3>
          </v-card-title>
          <ra-modal-close-button light @close-modal="close" />
        </div>
        <v-card-text>
          <v-row class="mt-5">
            <template v-if="ticketsWithActiveWindow && ticketsWithActiveWindow.length">
              <v-col cols="12" md="7">
                <template v-for="(ticket, index) in ticketsWithActiveWindow">
                  <div class="publicmodal__card-wrapper" :key="index">
                    <v-expansion-panels accordion>
                      <v-expansion-panel class="publicmodal__card pa-0 ra__card">
                        <v-expansion-panel-header>
                          <h3 class="eventdetails__schedule-title">{{ ticket.name }}</h3>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="d-flex flex-column flex-sm-row justify-sm-space-between">
                              <v-row>
                                <v-col cols="12" md="7">
                                  <!--  <div> -->
                                  <p class="publicmodal__card-data" v-html="ticket.description">
                                    {{ ticket.description }}
                                  </p>
                                  <p class="publicmodal__card-data">
                                    Ticket Type: {{ ticketType(ticket.type) }}
                                  </p>
                                  <p class="publicmodal__card-data mb-1">
                                    Available Until:
                                    {{ formatTime(ticket.schedule.end_date_time) }},
                                    {{ formatDate(ticket.schedule.end_date_time) }}
                                  </p>
                                  <!-- </div> -->
                                </v-col>
                                <v-col cols="12" md="5" class="text-sm-end mt-2 mt-sm-0">
                                  <h3 class="eventdetails__schedule-title mb-3">
                                    Price : {{ ticket.currency.iso_code }}{{ ticket.currency.symbol }}{{
                                      formatAmount(ticket.sales_price) }}
                                  </h3>
                                  <div class="publicmodal__card-select float-right">
                                    <v-select
                                      :items="ticketOptions(ticket.tickets_allowed, ticket.available_seats_count, ticket.is_ticket_free)"
                                      item-value="key" label="" solo dense placeholder="Select"
                                      @change="onSelectTickets(ticket, $event)"></v-select>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </template>
              </v-col>
              <v-col cols="12" md="5" class="publicmodal__card-summary--stick">
                <div class="publicmodal__card-summary">
                  <div class="text-center">
                    <h3 class="eventdetails__schedule-title">Order Summary</h3>
                  </div>
                  <template v-for="(order, index) in orderSummary">
                    <div class="d-flex justify-space-between" :key="index">
                      <p class="publicmodal__card-data">
                        {{ order.quantity }} x {{ order.name }}
                      </p>
                      <p class="publicmodal__card-data--dark">
                        {{ eventData.eventCurrency.iso_code }}{{ eventData.eventCurrency.symbol }}{{
                          formatAmount(order.subTotal) }}
                      </p>
                    </div>
                  </template>
                  <v-divider></v-divider>
                  <div class="d-flex justify-space-between">
                    <p class="publicmodal__card-data">Subtotal</p>
                    <p class="publicmodal__card-data--dark">
                      {{ eventData.eventCurrency.iso_code }}{{ eventData.eventCurrency.symbol }}{{ formatAmount(subtotal)
                      }}
                    </p>
                  </div>
                  <v-divider></v-divider>
                  <div class="d-flex justify-space-between">
                    <p class="publicmodal__card-data">Fees</p>
                    <p class="publicmodal__card-data--dark">
                      {{ eventData.eventCurrency.iso_code }}{{ eventData.eventCurrency.symbol }}{{ formatAmount(fees) }}
                    </p>
                  </div>
                  <div class="d-flex justify-space-between" v-if="hasTax">
                    <p class="publicmodal__card-data">{{ hasTax ? eventData.tax_name : 'Tax' }}</p>
                    <p class="publicmodal__card-data--dark">
                      {{ eventData.eventCurrency.iso_code }}{{ eventData.eventCurrency.symbol }}{{ formatAmount(totalTax)
                      }}
                    </p>
                  </div>
                  <v-divider></v-divider>
                  <div class="d-flex justify-space-between">
                    <p class="publicmodal__card-data">
                      <strong>Total</strong>
                    </p>
                    <p class="publicmodal__card-data--dark">
                      <strong>
                        {{ eventData.eventCurrency.iso_code }}{{ eventData.eventCurrency.symbol }}{{ formatAmount(total)
                        }}
                      </strong>
                    </p>
                  </div>
                  <p class="publicmodal__card-data font-italic mt-3">
                    Refund policy: {{ eventData.refundPolicy }} <br />
                    Fees: Please note that any fees are non-refundable
                  </p>
                  <div class="text-center publicmodal__card-summary--sticky">
                    <v-btn depressed large class="btn-primary" :loading="loading" @click="bookTicket(orderSummary)">
                      Book Tickets
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </template>
            <template v-else>
              <div class="text-center">
                <p class="lobby__bg-text">No tickets available for purchase</p>
              </div>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Select/Add attendees -->
    <v-dialog v-if="bookTicketsModal" v-model="bookTicketsModal" max-width="900">
      <v-form ref="attendeeForm">
        <v-stepper v-model="attendee_selection">
          <v-stepper-items v-for="(order, index) in orderSummary" :key="index">
            <v-stepper-content :step="index + 1" class="pa-0">
              <v-card class="event-modal__wrap ra">
                <div class="ra__form-heading">
                  <v-card-title class="ra__modal-title">
                    <h3 class="ra__modal-title--heading">
                      Select Your Attendees
                    </h3>
                  </v-card-title>
                  <ra-modal-close-button light @close-modal="closeAttendeeModal" />
                </div>
                <v-card-text class="pb-0">
                  <v-row class="sales__modal">
                    <v-col cols="12">
                      <h2 class="sales__modal-title">
                        Ticket {{ index + 1 }}: {{ order.name }} |
                        {{ ticketType(order.type) }}
                      </h2>
                      <p>
                        Description :
                        <span v-html="order.description">
                          {{ order.description }}
                        </span>
                      </p>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                  <v-row class="sales__modal" v-for="(attendee, i) in order.newAttendees" :key="i">
                    <v-col cols="12" lg="2">
                      <h2 class="sales__modal-title">Attendee {{ i + 1 }}:</h2>
                    </v-col>
                    <v-col cols="12" lg="10" v-if="i == 0">
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field label="First Name" outlined dense class="sales__modal-input"
                            v-model="attendee.first_name" :disabled="i == 0"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field label="Last Name" outlined dense class="sales__modal-input"
                            v-model="attendee.last_name" :disabled="i == 0"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field label="Email" outlined dense class="sales__modal-input" v-model="attendee.email"
                            :disabled="i == 0"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="10" v-else>
                      <v-row v-if="attendeesSelectionData.length > 0">
                        <v-col cols="12" md="12" lg="8">
                          <v-select :items="attendeesSelectionData" item-value="email" :item-text="itemText" item-id="id"
                            filled label="Choose Attendee" dense solo class="sales__modal-input" required return-object
                            @change="selectAttendee(order.id, $event, i, index)"></v-select>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12" md="3">
                          <v-text-field label="First Name" outlined dense class="sales__modal-input"
                            :rules="attendeerule.firstNameRules" v-model="attendee.first_name"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field label="Last Name" outlined dense class="sales__modal-input"
                            :rules="attendeerule.lastNameRules" v-model="attendee.last_name"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field label="Email" outlined dense class="sales__modal-input"
                            :rules="attendeerule.emailRules" v-model="attendee.email"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="addNewAttendeeFlag[i]">
                        <v-col cols="12" md="3">
                          <v-text-field label="First Name" outlined dense class="sales__modal-input"
                            :rules="attendeerule.firstNameRules" v-model="attendee.first_name"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field label="Last Name" outlined dense class="sales__modal-input"
                            :rules="attendeerule.lastNameRules" v-model="attendee.last_name"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field label="Email" outlined dense class="sales__modal-input"
                            :rules="attendeerule.emailRules" v-model="attendee.email"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
                <center>
                  <span class="errorMsg">{{ formError ? formError : "" }}</span>
                </center>
                <v-card-actions class="text-center justify-center mb-4 px-4">
                  <v-btn v-if="index > 0" large depressed outlined class="btn-outline-primary"
                    @click="attendee_selection = previousStep(index)">
                    Back
                  </v-btn>
                  <v-btn v-if="index < orderSummary.length - 1" large depressed class="btn-primary"
                    @click="attendee_selection = nextStep(index + 1, order.newAttendees, order.id)">
                    Next
                  </v-btn>
                  <v-btn v-else large depressed class="btn-primary px-4" @click="checkout(order.newAttendees)">
                    Checkout
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>
    </v-dialog>
    <!--  dialog to make user get loggedin or register -->
    <v-dialog v-model="getLoggedIn" width="700">
      <v-card class="event-modal__wrap ra">
        <div class="ra__form-heading">
          <v-card-title class="ra__modal-title">
            <h3 class="ra__modal-title--heading mb-2">Login/Register</h3>
          </v-card-title>
        </div>
        <v-card-text class="invite__form mt-0 rounded-0">
          <v-row class="align-center">
            <v-col cols="12" lg="12">
              <div class="">
                <!-- New User -->
                <v-form v-if="isNewUser" ref="registerForm" lazy-validation @submit.prevent="register"
                  aria-autocomplete="off" autocomplete="off">
                  <v-alert v-if="form.errors.get('error')" outlined transition="scale-transition" type="error">
                    {{ form.errors.get("error") }}
                  </v-alert>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("first_name") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-first-name" v-model="form.first_name" flat solo
                        :rules="rules.firstNameRules" :label="$t('first_name')" required />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("last_name") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-last-name" v-model="form.last_name" flat solo
                        :rules="rules.lastNameRules" :label="$t('last_name')"
                        :error-messages="form.errors.get('last_name')" required />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("email") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-email" v-model="form.email" flat solo aria-autocomplete="false"
                        :rules="rules.emailRules" :label="$t('email')" @change="checkEmailExist" required />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("new_password") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-password" v-model="form.password" type="password"
                        :error-messages="form.errors.get('password')" :rules="rules.passwordRules" flat solo
                        :label="$t('new_password')" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("confirm_password") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-confirm-password" v-model="form.password_confirmation"
                        type="password" :label="$t('confirm_password')"
                        :error-messages="form.errors.get('password_confirmation')"
                        :rules="rules.confirmPasswordRules.concat(passwordConfirmationRule)" flat solo />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="flex justify-content-center">
                      <div class="mb-3">
                        <vue-recaptcha ref="recaptcha" @verify="isVerified" :sitekey="captchaSiteKey"></vue-recaptcha>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn ref="ref-registerForm-submit-btn" x-large type="submit" block :loading="form.busy"
                        class="btn-primary">
                        Continue
                        <v-icon light> mid-key </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <!-- Existing User -->
                <v-form v-else ref="login" lazy-validation @submit.prevent="login">
                  <v-alert v-if="form.errors.get('error')" outlined transition="scale-transition" type="error">
                    {{ form.errors.get("error") }}
                  </v-alert>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("email") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-email" v-model="form.email" flat solo
                        label="Enter Email Address" @keyup="checkEmailExist" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <label class="ra__fields-label ra-fields--text-input__label">
                        {{ $t("password") }}
                      </label>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field ref="ref-registerForm-password" v-model="form.password" type="password"
                        :error-messages="form.errors.get('password')" flat solo :label="$t('password')" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-btn ref="ref-registerForm-submit-btn" x-large type="submit" block :loading="form.busy"
                        class="btn-primary">
                        <span class="white--text"> Pay Now </span>
                        <v-icon light> mid-key </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import RaModalCloseButton from "~/components/general/RaModalCloseButton";
import VueRecaptcha from 'vue-recaptcha';
import moment from "moment";
import billingConfig from "~/plugins/config/billingParameters";
import isEmpty from "lodash/isEmpty";
import Form from "vform";
import Vue from "vue";
export default {
  layout: "default",
  components: { RaModalCloseButton, VueRecaptcha },
  name: "BookTickets",
  props: {
    ticketsWithActiveWindow: {
      type: Array,
      default: () => {
        return [];
      },
    },
    eventData: {
      type: Object,
      default: () => { },
    },
  },
  data: () => ({
    availableTicketModal: false,
    subtotal: 0,
    fees: 0,
    seatFees: 0,
    raFees: 0,
    total: 0,
    totalTax: 0,
    totalTransactionCharge: 0,
    stripeFees: 0,
    orderSummary: [],
    bookTicketsModal: false,
    loading: false,
    hasMultiTicket: false,
    isSaving: false,
    nextLoading: false,
    recaptcha: null,
    attendeerule: {
      firstNameRules: [
        (v) => !!v || "First Name is required",
        (v) => (v && v.length <= 40) || "Name must be less than 40 characters",
      ],
      lastNameRules: [
        (v) => !!v || "Last Name is required",
        (v) => (v && v.length <= 40) || "Name must be less than 40 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) ||
          "E-mail must be valid",
      ],
      attendeeSelectionRules: [
        (v) => !!v || "Select at least one attendee or add new attendee",
      ],
    },
    timeout: 2000,
    attendee_selection: 0,
    attendeesSelectionData: [],
    addNewAttendeeFlag: {},
    getLoggedIn: false,
    isNewUser: true,
    rules: {
      firstNameRules: [(v) => !!v || "First Name is required"],
      lastNameRules: [(v) => !!v || "Last Name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) ||
          "E-mail must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 8) || "Password must be more than 8 characters",
        (v) => /(?=.*[a-z])/.test(v) || "Must have one lower character",
        (v) => /(?=.*[A-Z])/.test(v) || "Must have one uppercase character",
        (v) => /(?=.*\d)/.test(v) || "Must have one number",
        (v) => /([!@$%])/.test(v) || "Must have one special character [!@#$%]",
      ],
      confirmPasswordRules: [(v) => !!v || "Confirm Password is required"],
    },
    form: new Form({
      email: "",
      password: "",
      recaptcha: null
    }),
    formError: "",
    seatFeesVat: 0,
    raFeesVat: 0,
    netAmount: 0,
    amountInfo: [],
    taxInfo: [],
    captchaSiteKey: process.env.MIX_NOCAPTCHA_SITEKEY
  }),
  computed: {
    ...mapGetters({ user: "auth/user", authenticated: "auth/check" }),
    passwordConfirmationRule() {
      return () =>
        this.form.password === this.form.password_confirmation ||
        "The password confirmation does not match.";
    },
    hasVat() {
      return !!(this.user &&
        this.user.address &&
        this.user.address.country &&
        this.user.address.country.country_code == "GB" &&
        this.user.tax_id);
    },
    hasTax() {
      return !!this.eventData.tax_name
    }
  },
  mounted() {
    if (this.$route?.hash == '#open') {
      this.availableTicketModal = true
    }
  },
  methods: {
    formatDate(datetime) {
      return moment(datetime).format("Do MMMM, YYYY");
    },
    formatTime(datetime) {
      return moment(datetime).format("h:mm a");
    },
    formatAmount(val) {
      if (val != null) {
        return Number(val).toFixed(2);
      }
    },
    ticketType(type) {
      if (type === "virtual") {
        return "Online Only";
      } else if (type === "in_person") {
        return "In-Person";
      } else if (type === "hybrid") {
        return "In-Person & Online";
      }
    },
    close() {
      this.availableTicketModal = false;
      this.orderSummary = [];
    },
    calculateSeatFees(type, quantity) {
      let currencyCode = this.eventData.eventCurrency.iso_code.toLowerCase()
      return type == "in_person" ? 0 : (quantity * billingConfig.seat_charge[currencyCode]).toFixed(2)
    },
    calculateSeatFeesVat(type, quantity) {
      let currencyCode = this.eventData.eventCurrency.iso_code.toLowerCase()
      const fee = type == "in_person" ? 0 : (quantity * billingConfig.seat_charge[currencyCode]).toFixed(2)
      return parseFloat(fee * (billingConfig.tax_rate / 100))
    },
    calculateRaFees(price) {
      return this.eventData.ownerPlan.eventOwnerTicketCharge * price
    },
    calculateRaFeesVat(price) {
      const charge = this.eventData.ownerPlan.eventOwnerTicketCharge * price
      return parseFloat(charge * (billingConfig.tax_rate / 100))
    },
    calculateTransactionCharge(price) {
      return price * billingConfig.transaction_percent
    },
    calculateEOTax(price) {
      let tax = 0
      if (this.eventData.is_tax_required && this.eventData.tax_percentage != null) {
        if (this.eventData.tax_inclusive_ticket_price) {
          //=B3-(B3/(1+(B4/100)))
          tax = price - (price / (1 + (this.eventData.tax_percentage / 100)))
        } else {
          //=C3*(C4/100)
          tax = price * (this.eventData.tax_percentage / 100)
        }
      }
      this.totalTax = this.totalTax + tax
      return tax
    },
    calculateNetAmount(price, currencyCode, type, quantity) {
      if (this.eventData.ownerCountry == "GB") {
        return price - this.calculateTransactionCharge(price) - this.calculateSeatFees(type, quantity) - this.calculateRaFees(price) - this.calculateSeatFeesVat(type, quantity) - this.calculateRaFeesVat(price)
      } else {
        return price - this.calculateTransactionCharge(price) - this.calculateSeatFees(type, quantity) - this.calculateRaFees(price)
      }
    },
    ticketOptions(val, available_seats_count, isFree) {
      var element = [];
      for (let index = 0; index <= val; index++) {
        if (isFree == 0) {
          element.push(index);
        } else {
          if (val <= available_seats_count) element.push(index);
        }
      }
      return element;
    },
    onSelectTickets(ticket, val) {
      const newAttendees = [];
      if (val > 0) {
        for (let index = 0; index < val; index++) {
          if (index == 0 && !isEmpty(this.user)) {
            newAttendees.push({
              ticketId: ticket.id,
              first_name: this.user.first_name,
              last_name: this.user.last_name,
              email: this.user.email,
            });
          } else {
            newAttendees.push({
              ticketId: ticket.id,
              first_name: "",
              last_name: "",
              email: "",
            });
          }
        }
      }
      let currencyCode = this.eventData.eventCurrency.iso_code.toLowerCase()
      const dataObject = {
        id: ticket.id,
        quantity: val,
        newAttendees: newAttendees,
        name: ticket.name,
        description: ticket.description,
        type: ticket.type,
        is_free: ticket.is_ticket_free,
        price: ticket.sales_price,
        subTotal: ticket.sales_price * val,
        seatFees: ticket.is_ticket_free ? 0 : this.calculateSeatFees(ticket.type, val),
        seatFeesVat: ticket.is_ticket_free || this.eventData.ownerCountry != "GB" ? 0 : this.calculateSeatFeesVat(ticket.type, val),
        raFees: ticket.is_ticket_free ? 0 : this.calculateRaFees(ticket.sales_price * val),
        raFeesVat: ticket.is_ticket_free || this.eventData.ownerCountry != "GB" ? 0 : this.calculateRaFeesVat(ticket.sales_price * val),
        transactionCharge: this.calculateTransactionCharge(ticket.sales_price * val),
        taxPrice: ticket.is_ticket_free ? 0 : this.calculateEOTax(ticket.sales_price * val),
        netAmount: ticket.is_ticket_free ? 0 : this.calculateNetAmount(ticket.sales_price * val, currencyCode, ticket.type, val)
      };
      if (val > 0) {
        if (!this.orderSummary.some((data) => data.id === ticket.id)) {
          this.orderSummary.push(dataObject);
        } else {
          Vue.set(
            this.orderSummary,
            this.orderSummary.findIndex((f) => f.id === ticket.id),
            dataObject
          );
        }
      } else {
        let index = this.orderSummary.findIndex((data) => data.id === ticket.id)
        this.orderSummary.splice(index, 1);
      }
      this.subtotal = this.orderSummary.reduce((sub, order) => sub + Number(order.subTotal), 0)

      this.stripeFees = this.subtotal > 0 ? billingConfig.transaction_charge[currencyCode] : 0
      this.totalTransactionCharge = this.orderSummary.reduce((charge, order) => Number(parseFloat(charge) + parseFloat(order.transactionCharge)), 0)

      this.seatFees = this.orderSummary.reduce((seatFee, order) => Number(parseFloat(seatFee) + parseFloat(order.seatFees)), 0)
      this.seatFeesVat = this.orderSummary.reduce((seatVat, order) => Number(parseFloat(seatVat) + parseFloat(order.seatFeesVat)), 0)

      this.raFees = this.orderSummary.reduce((raFee, order) => Number(parseFloat(raFee) + parseFloat(order.raFees)), 0)
      this.raFeesVat = this.orderSummary.reduce((raVat, order) => Number(parseFloat(raVat) + parseFloat(order.raFeesVat)), 0)

      const vatFee = this.seatFees + this.raFees + this.stripeFees + this.totalTransactionCharge + this.seatFeesVat + this.raFeesVat
      const noVatFee = this.seatFees + this.raFees + this.stripeFees + this.totalTransactionCharge
      this.fees = this.eventData.ownerCountry == "GB" ? vatFee : noVatFee

      this.totalTax = this.orderSummary.reduce((tax, order) => tax + Number(order.taxPrice), 0)
      this.total = this.eventData.tax_inclusive_ticket_price ? this.subtotal : parseFloat(this.subtotal) + parseFloat(this.fees) + parseFloat(this.totalTax)
      this.netAmount = this.total - this.fees - this.totalTax
    },
    bookTicket(orderSummary) {
      if (isEmpty(this.user)) {
        this.getLoggedIn = true;
      } else {
        this.loading = true
        axios
          .get("attendee-selection")
          .then((response) => {
            this.attendeesSelectionData = response.data.attendee_selection;
            if (this.attendeesSelectionData.length > 0) {
              this.attendeesSelectionData.push({
                id: 0,
                name: "+ Add New Attendee...",
                email: "",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false
          })
        var data = orderSummary
          .filter(function (obj) {
            if (obj.quantity > 1) return obj.quantity;
          })
          .map(function (obj) {
            return obj.id;
          });
        this.availableTicketModal = false;
        if (data.length > 0) {
          this.bookTicketsModal = true;
          this.attendee_selection = 1;
        } else {
          !isEmpty(orderSummary)
            ? this.redirectToPurchase()
            : (this.availableTicketModal = true);
        }
      }
    },
    closeAttendeeModal() {
      this.bookTicketsModal = false;
    },
    nextStep(val, newAttendees, ticketId) {
      let notFilledData;
      newAttendees.forEach((element) => {
        if (
          element.first_name == "" ||
          element.last_name == "" ||
          element.email == ""
        ) {
          notFilledData = true;
          return false;
        }
      });
      const emails = [...new Set(newAttendees.map((item) => item.email))];
      if (notFilledData == true) {
        this.formError =
          "You have errors on this form. Please fill all fields before proceeding!";
      } else if (emails.length < newAttendees.length) {
        this.formError =
          "You have duplicate emails entered. Please add unique users data";
      } else {
        this.formError = "";
        this.addAttendeeMapping(newAttendees);
        return val + 1;
      }
    },
    previousStep(val) {
      this.formError = "";
      return val;
    },
    addAttendeeMapping(newAttendees) {
      if (newAttendees.length > 1) {
        this.nextLoading = true;
        axios
          .post("/attendee-selection", { newAttendees: newAttendees })
          .then((response) => {
            this.attendeesSelectionData = response.data.attendee_selection;
            if (this.attendeesSelectionData.length > 0) {
              this.attendeesSelectionData.push({
                id: 0,
                name: "+ Add New Attendee...",
                email: "",
              });
            }
            this.nextLoading = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    isVerified(response) {
      this.form.recaptcha = response
    },
    checkout(newAttendees) {
      let notFilledData;
      newAttendees.forEach((element) => {
        if (
          element.first_name == "" ||
          element.last_name == "" ||
          element.email == ""
        ) {
          notFilledData = true;
          return false;
        }
      });
      const emails = [...new Set(newAttendees.map((item) => item.email))];
      if (notFilledData == true) {
        this.formError =
          "You have errors on this form. Please fill all fields before proceeding!";
      } else if (emails.length < newAttendees.length) {
        this.formError =
          "You have duplicate emails entered. Please add unique users data";
      } else {
        this.formError = "";
        this.addAttendeeMapping(newAttendees);
        this.redirectToPurchase();
      }
    },
    redirectToPurchase() {
      this.amountInfo.push({
        subtotal: parseFloat(this.formatAmount(this.subtotal)),
        stripeFees: parseFloat(this.formatAmount(this.stripeFees)),
        totalTransactionCharge: parseFloat(this.formatAmount(this.totalTransactionCharge)),
        seatFees: parseFloat(this.formatAmount(this.seatFees)),
        raFees: parseFloat(this.formatAmount(this.raFees)),
        seatFeesVat: parseFloat(this.formatAmount(this.seatFeesVat)),
        raFeesVat: parseFloat(this.formatAmount(this.raFeesVat)),
        fees: parseFloat(this.formatAmount(this.fees)),
        totalTax: parseFloat(this.formatAmount(this.totalTax)),
        total: parseFloat(this.formatAmount(this.total)),
        netAmount: parseFloat(this.formatAmount(this.netAmount))
      })
      console.log("amountInfo", this.amountInfo);
      this.taxInfo.push({
        taxInclusive: this.eventData.tax_inclusive_ticket_price,
        taxName: this.eventData.tax_name,
        taxPercentage: this.eventData.tax_percentage,
        taxRequired: this.eventData.is_tax_required,
      })
      this.$router.push({
        name: "multiTicketSales",
        params: {
          orderSummary: this.orderSummary,
          eventName: this.eventData.eventName,
          eventCurrency: this.eventData.eventCurrency,
          eventId: this.eventData.eventId,
          redirectUrl: this.eventData.redirectUrl,
          taxInfo: this.taxInfo[0],
          ownerCountry: this.eventData.ownerCountry,
          amountInfo: this.amountInfo[0]
        },
      });
    },
    itemText(item) {
      return `${item.name}  ${item.email}`;
    },
    selectAttendee(tickeId, item, key, ticketIndex) {
      if (item.id == 0) {
        if (!this.addNewAttendeeFlag.hasOwnProperty(key)) {
          this.addNewAttendeeFlag = { ...this.addNewAttendeeFlag, [key]: true };
        }
      } else {
        if (this.addNewAttendeeFlag.hasOwnProperty(key)) {
          this.addNewAttendeeFlag = {
            ...this.addNewAttendeeFlag,
            [key]: false,
          };
        }
        this.orderSummary[ticketIndex].newAttendees[key] = {
          ticketId: tickeId,
          first_name: item.first_name,
          last_name: item.last_name,
          email: item.email,
        };
      }
    },
    checkEmailExist() {
      axios
        .get("check-email/" + this.form.email)
        .then((response) => {
          if (response.data === "notExist") {
            this.isNewUser = true;
          } else {
            this.isNewUser = false;
            this.$store.dispatch("snackbar/showSnack", {
              text:
                "This email is already linked to an account. Please login to complete your purchase",
              color: "warning",
              timeout: 2000,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async register() {
      if (this.isNewUser && this.$refs.registerForm.validate()) {
        try {
          // Change Password the user.
          const { data } = await this.form.post("/register");
          // Must verify email first.
          if (data.status) {
            this.mustVerifyEmail = true;
          } else {
            // Log in the user.
            const { data } = await this.form.post("/login");
            // Save the token.
            this.$store.dispatch("auth/saveToken", {
              token: data.access_token,
            });
            this.afterLoginCalls();
          }
        } catch (e) {
          this.$refs.recaptcha.reset();
        }
      }
    },
    async login() {
      if (!this.isNewUser && this.$refs.login.validate()) {
        try {
          const response = await this.form.post("/login");
          this.$store.dispatch("auth/saveToken", {
            token: response.data.access_token,
            remember: this.remember,
          });
          this.afterLoginCalls();
        } catch (e) {
          this.showErrorMessage = true;
          this.errorText = this.$t("login_error_text");
          console.log(e);
        }
      }
    },
    async afterLoginCalls() {
      // Fetch the user.
      await this.$store.dispatch("auth/fetchUser");
      this.getLoggedIn = false;
      //after user login/resister append logged in user to first index
      let currencyCode = this.eventData.eventCurrency.iso_code.toLowerCase()

      // Reset the calculation of the tax
      this.totalTax = 0;

      this.orderSummary.forEach((order) => {
        if (order.quantity >= 1) {
          order.subTotal = order.price * order.quantity,
            order.seatFees = order.is_free ? 0 : this.calculateSeatFees(order.type, order.quantity),
            order.seatFeesVat = order.is_free || this.eventData.ownerCountry != "GB" ? 0 : this.calculateSeatFeesVat(order.type, order.quantity),
            order.raFees = order.is_free ? 0 : this.calculateRaFees(order.subTotal),
            order.raFeesVat = order.is_free || this.eventData.ownerCountry != "GB" ? 0 : this.calculateRaFeesVat(order.subTotal),
            order.transactionCharge = order.is_free ? 0 : this.calculateTransactionCharge(order.price * order.quantity),
            order.taxPrice = order.is_free ? 0 : this.calculateEOTax(order.price * order.quantity),
            order.netAmount = order.is_free ? 0 : this.calculateNetAmount(order.price * order.quantity, this.eventData.eventCurrency.iso_code.toLowerCase(), order.type, order.quantity)
          order.newAttendees[0] = {
            ticketId: order.id,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
          };
        }
      });
      // open attendee selection form
      this.bookTicket(this.orderSummary);
    },
    openAvailableTicketModal() {
      if (window.location.href.indexOf("isExternalPage=true") > -1) {
        let newUrl = `${window.config.appUrl}public/${this.eventData.eventId}#open`;
        window.open(newUrl, "_blank");
      } else {
        this.availableTicketModal = true
      }
    }
  },
};
</script>
